export enum ChatMessageType {
    text = 'text',
    media = 'media',
}
